// extracted by mini-css-extract-plugin
module.exports = {"citation":"BookCitationPageView__citation"};